import { render, staticRenderFns } from "./CASign.vue?vue&type=template&id=57c72d5c&scoped=true&"
import script from "./CASign.vue?vue&type=script&lang=ts&"
export * from "./CASign.vue?vue&type=script&lang=ts&"
import style0 from "./CASign.vue?vue&type=style&index=0&id=57c72d5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c72d5c",
  null
  
)

export default component.exports